// extracted by mini-css-extract-plugin
export default {"Container":"RateLimitedPage_Container__DrM9c"};